import React, { useState } from "react";

import "./_styles/login.scss";
import Pay2logo from "../../assets/images/logoBlack.svg";
import ChangePassword from "../Settings/ChangePassword";
import loginMobileImage from "../../assets/images/loginMobileImage.png";

const PssswordExp = ({ inRegister, setInRegister }) => {


  return (
    <div className="main-div loginMainDiv flex">
      <div className="login_wrapper">
          <div className="img" style={{display:"flex",alignItems:"center", minHeight:"100vh"}}>
        <img src={loginMobileImage} alt="waves" />
      </div>
          <div className="right">
    

      <div className="login_form_wrapper">
        <div className="login_form">
          <div className="logo" style={{padding:"0 20px 40px"}}>
            <img style={{height:"40px",width:"auto", margin:"auto"}} src={Pay2logo} alt="logo" />
          </div>
          <div className="form">
            <p className="fs-20 mt-20 fw-700">Reset Your Password.</p>

            {<p className="fs-16 mt-14">You can reset your password here.</p>}

              <ChangePassword />
          </div>
        </div>
      </div>
    </div>
     
      </div>
    </div>
  );
};

export default PssswordExp;